import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { KeyboardService } from 'src/app/services/keyboard/keyboard.service';

class ViewModel {
  title?: string;
  message: string;
  errorDetails?: string;
  constructor(message: string, title: string, errorDetails?: string) {
    this.message = message;
    this.title = title;
    this.errorDetails = errorDetails;
  }
}

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.css'],
    standalone: false
})
export class ErrorDialogComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  viewModel?: ViewModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
      private keyboardService: KeyboardService,
    private dialogRef: MatDialogRef<ErrorDialogComponent>) { }

  ngOnInit(): void {
    this.viewModel = new ViewModel(this.data.errorMessage, this.data.title, this.data.errorDetails);
    this.keyboardService.onKey('Escape', () => { this.dialogRef.close(); }, this.destroyRef);
    this.keyboardService.onKey('Enter',  () => { this.dialogRef.close(); }, this.destroyRef);
  }
}
